import strings from "assets/strings";
import Text from "components/text/Text";
import Popup from "components/popup/Popup";
import settings from "assets/mergeSettings";
import "instantsearch.css/themes/satellite.css";
import { ArrowLeft, ArrowUp } from "assets/icons";
import Button from "components/buttons/button/Button";
import { KeyValuePair, objectTypeProps } from "types";
import styles from "./SearchMedicalCenters.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import SearchAdressMedicalCenters from "./SearchAdressMedicalCenters";
import { visitDaysOptions, visitHoursOptions } from "assets/constants";
import { isEmergencyOptions, localAttributes } from "assets/constants";
import {
  getAllClassNames,
  getHebDayByCurentDay,
  isDev,
  setParams,
} from "helpers";
import { DropdownCheckboxes } from "components/dropdownCheckboxes/DropdownCheckboxes";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import { validateRecaptcha } from "../../../utils/recaptcha";
import { Loader } from "components/Loader/Loader";

export function SearchMedicalCenters(props: objectTypeProps) {
  const { objectType } = props;
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [isEmergency, setIsEmergency] = useState(false);
  const [workHours, setWorkHours] = useState<string[]>([]);
  const [daysOfWeek, setDaysOfWeek] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [isValidAddress, setIsValidAddress] = useState(false);
  const [isAddressEnabled, setIsAddressEnabled] = useState(false);
  const [medicalServices, setMedicalServices] = useState<string[]>([]);
  const [selectedPlace, setSelectedPlace] = useState<{
    city: string;
    lat: number | null;
    lng: number | null;
  }>({
    city: "",
    lat: null,
    lng: null,
  });
  const divExpandRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  let searchResultsPage: string = "";
  switch (objectType) {
    case 1:
      searchResultsPage = settings.doctorSearchResults;
      break;
    case 2:
      searchResultsPage = settings.dietSearchResults;
      break;
    case 3:
      searchResultsPage = settings.socialWorkerSearchResults;
      break;
    case 4:
      searchResultsPage = settings.medicalCenterSearchResults;
      break;
    case 5:
      searchResultsPage = settings.opticaSearchResults;
      break;
    case 6:
      searchResultsPage = settings.emergencySearchResults;
      break;
    case 7:
      searchResultsPage = settings.pharmacySearchResults;
      break;
    case 8:
      searchResultsPage = settings.womenEmergencySearchResults;
      break;
    case 9:
      searchResultsPage = settings.dentalSearchResults;
      break;
  }

  const handelIsEmergency = (selectedData: string[]) => {
    setIsEmergency(selectedData.includes("true"));
  };

  useEffect(() => {
    if (isEmergency) {
      setDaysOfWeek([getHebDayByCurentDay()]);
    }
  }, [isEmergency]);

  useEffect(() => {
    const resetLoadingState = () => {
      setLoading(false);
    };

    window.addEventListener("popstate", resetLoadingState);
    window.addEventListener("pageshow", resetLoadingState);

    return () => {
      window.removeEventListener("popstate", resetLoadingState);
      window.removeEventListener("pageshow", resetLoadingState);
    };
  }, []);

  const onSubmit = async (event: any) => {
    event.preventDefault();

    const isValid = await validateRecaptcha('search_medical_centers');
    if (!isValid) {
      alert('אימות נכשל. נסה שוב.');
      return;
    }

    // Use selectedPlace if available
    if (selectedPlace.lat && selectedPlace.lng && isValidAddress) {
      const loc = `${selectedPlace.lat},${selectedPlace.lng}`;

      const formData: KeyValuePair[] = [
        { key: `${[localAttributes.localOuterServiceName]}`, value: name },

        {
          key: `${[localAttributes.localdaysOfWeekFieldName]}`,
          value: daysOfWeek.join(","),
        },
        {
          key: `${[localAttributes.localWorkHoursFieldName]}`,
          value: workHours.join(","),
        },

        { key: "loc", value: loc },
        { key: "r", value: "20000" },
      ];

      if (objectType === 9) {
        formData.unshift({
          key: `${[localAttributes.localMedicalServicesApiKey]}`,
          value: medicalServices.join(","),
        });
      }

      setLoading(true);
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
      return;
    }

    if (objectType === 9 && !name && !city && medicalServices.length === 0) {
      handleToggleVisibility();
    } else if (objectType == 1 && !medicalServices && !name) {
      handleToggleVisibility();
    } else if (
      objectType != 1 &&
      objectType != 6 &&
      objectType != 9 &&
      !city &&
      !name
    ) {
      handleToggleVisibility();
    } else {
      const formData: KeyValuePair[] = [
        {
          key: `${[localAttributes.localMedicalServicesApiKey]}`,
          value: medicalServices.join(","),
        },
        { key: `${[localAttributes.localOuterServiceName]}`, value: name },
        //{ key: `${[localAttributes.localOuterServiceQuery]}`, value: name },
        { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
        {
          key: `${[localAttributes.localdaysOfWeekFieldName]}`,
          value: daysOfWeek.join(","),
        },
        {
          key: `${[localAttributes.localWorkHoursFieldName]}`,
          value: workHours.join(","),
        },
      ];

      if (city && city.split(",").length == 1) {
        const cities = localStorage.getItem("cities");
        const citiesArr = cities && JSON.parse(cities);
        const locLat = citiesArr.find((c: any) => c.cityCode === city)
          ?.latitude;
        const locLLong = citiesArr.find((c: any) => c.cityCode === city)
          ?.longitude;
        formData.push(
          {
            key: `${[localAttributes.localLocFieldName]}`,
            value: `${locLat},${locLLong}`,
          },
          { key: `${[localAttributes.localRadiusFieldName]}`, value: "20000" }
        );
      }
      setLoading(true);
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
    }
  };

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector("input");
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle("show");
    }
  };

  useEffect(() => {
    setIsAddressEnabled(false);
  }, []);

  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >
      <div className={styles.container}>
        <div
          className={getAllClassNames([
            styles.searchDiv,
            expanded && styles.noBorderBottom,
          ])}
        >
          {objectType !== 9 ? (
            <div className={`${styles.row} ${styles.rowThree}`}>
              <CustomLocalSearchInput
                popupProps={{
                  title: "",
                  subTitle: "",
                  placeholder: "",
                  keyToNormalize: "name",
                  labelToNormalize: "name",
                  onSubmit: () => {},
                }}
                enableFreeText={!isAddressEnabled}
                attribute={localAttributes.localDoctorNamesApiKey}
                title={strings.searchMedicalCenters.name}
                queryParams={[{ key: "objectType", value: objectType }]}
                onChange={(value: string) => setName(value)}
                onReset={() => setName("")}
              />

              <CustomLocalSearchInput
                multiSelect
                isPopup={!isAddressEnabled}
                popupProps={{
                  title: strings.globalStrings.chooseCity,
                  subTitle: strings.globalStrings.canChooseCity,
                  placeholder: strings.globalStrings.searchCity,
                  keyToNormalize: "cityCode",
                  labelToNormalize: "city",
                  onSubmit: () => {},
                }}
                placeholder={strings.globalStrings.cityPlaceholder}
                enableFreeText={!isAddressEnabled}
                attribute={localAttributes.localCitiesApiKey}
                title={strings.globalStrings.city}
                queryParams={[{ key: "objectType", value: objectType }]}
                onChange={(value: string) => {
                  setCity(value);
                }}
                onReset={() => setCity("")}
                showRadioButtonCheckBox={true}
                isEnabledRadioButton={!isAddressEnabled}
                setIsEnabledRadioButton={setIsAddressEnabled}
              />

              <SearchAdressMedicalCenters
                onPlaceSelected={(details) =>
                  setSelectedPlace({
                    city: details.city,
                    lat: details.lat,
                    lng: details.lng,
                  })
                }
                isEnabled={isAddressEnabled}
                setIsEnabled={setIsAddressEnabled}
                setIsValidAddress={setIsValidAddress}
              />
            </div>
          ) : (
            <>
              <div className={styles.row}>
                <CustomLocalSearchInput
                  popupProps={{
                    title: "",
                    subTitle: "",
                    placeholder: "",
                    keyToNormalize: "name",
                    labelToNormalize: "name",
                    onSubmit: () => {},
                  }}
                  enableFreeText={!isAddressEnabled}
                  attribute={localAttributes.localDoctorNamesApiKey}
                  title={strings.searchMedicalCenters.name}
                  queryParams={[{ key: "objectType", value: objectType }]}
                  onChange={(value: string) => setName(value)}
                  onReset={() => setName("")}
                />

                <DropdownCheckboxes
                  title={strings.searchDoctors.medicalField}
                  objectType="9"
                  attribute={localAttributes.localMedicalApiKey}
                  keyToNormalize={localAttributes.localMedicalFieldName}
                  labelToNormalize={localAttributes.localMedicalFieldName}
                  setQueryParams={(values: string[]) =>
                    setMedicalServices(values)
                  }
                  placeholder={
                    strings.searchMedicalCenters.medicalFieldPlaceholder
                  }
                  disabled={false}
                />
              </div>

              <div className={styles.row}>
                <CustomLocalSearchInput
                  multiSelect
                  isPopup={!isAddressEnabled}
                  popupProps={{
                    title: strings.globalStrings.chooseCity,
                    subTitle: strings.globalStrings.canChooseCity,
                    placeholder: strings.globalStrings.searchCity,
                    keyToNormalize: "cityCode",
                    labelToNormalize: "city",
                    onSubmit: () => {},
                  }}
                  placeholder={strings.globalStrings.cityPlaceholder}
                  enableFreeText={!isAddressEnabled}
                  attribute={localAttributes.localCitiesApiKey}
                  title={strings.globalStrings.city}
                  queryParams={[{ key: "objectType", value: objectType }]}
                  onChange={(value: string) => {
                    setCity(value);
                  }}
                  onReset={() => setCity("")}
                  showRadioButtonCheckBox={true}
                  isEnabledRadioButton={!isAddressEnabled}
                  setIsEnabledRadioButton={setIsAddressEnabled}
                />

                <SearchAdressMedicalCenters
                  onPlaceSelected={(details) =>
                    setSelectedPlace({
                      city: details.city,
                      lat: details.lat,
                      lng: details.lng,
                    })
                  }
                  isEnabled={isAddressEnabled}
                  setIsEnabled={setIsAddressEnabled}
                  setIsValidAddress={setIsValidAddress}
                  disabled={name.trim().length > 0}
                />
              </div>
            </>
          )}
        </div>
        {expanded && (
          <div className={styles.divExpand} ref={divExpandRef}>
            <CustomCheckboxesLocal
              isFlex
              onSetSelected={(selectedData: string[]) =>
                setDaysOfWeek(selectedData)
              }
              title={strings.globalStrings.visitDays}
              options={visitDaysOptions}
              selectedCheckboxes={daysOfWeek}
            />
            {objectType === 6 && (
              <CustomCheckboxesLocal
                isFlex
                onSetSelected={(selectedData: string[]) =>
                  handelIsEmergency(selectedData)
                }
                options={isEmergencyOptions}
                selectedCheckboxes={isEmergency ? ["true"] : []}
              />
            )}
            {objectType != 6 && objectType != 8 && (
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) =>
                  setWorkHours(selectedData)
                }
                title={strings.globalStrings.visitHours}
                options={visitHoursOptions}
                selectedCheckboxes={workHours}
              />
            )}
          </div>
        )}
        {settings.showAdvanceSearch ? (
          <div className={styles.divBottom}>
            <div>
              <Text
                onClick={() => setExpanded(!expanded)}
                className={styles.textAdvance}
                text={
                  expanded
                    ? strings.globalStrings.closeAdvancedSearch
                    : strings.globalStrings.advanceSearch
                }
              />
              {expanded ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowLeft className={styles.icon} />
              )}
            </div>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        ) : (
          <div className={styles.divBottomNoAavanced}>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        )}
      </div>
      {
        <Popup
          ref={popupRef}
          onClose={() => handleToggleVisibility()}
          height={284}
          width={550}
          style={{ paddingBottom: "0px" }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={strings.errorMessages.requiredProperties}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
      }
      <Loader visible={loading} />
    </div>
  );
}
